import Component from 'vue-class-component';
import { required, url, maxLength } from 'vuelidate/lib/validators'
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import { Mixins, Prop } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';


@Component({
  name: 'ed-lesson-create-video',
  components: {
    EdSelectTag: () => import(/* EdSelectTag */'@/courses/components/ed-select-tag/ed-select-tag.component.vue')
  }
})
export default class EdLessonCreateVideoComponent extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: any; //Typescript upgrade
  declare readonly params: any; 

  public form: any = null;
  public section: Section = null;
  public title: string = '';
  public saving: boolean = false;
  public tags: Array<string> = ['TEST', 'CLASSWORK', 'HOMEWORK'];
  public tagSelected: string = '';

  get creating() {
    return 'section' in this.params || this.section == null;
  }

  get isVideoURLChanged() {
    return !this.creating && this.form.url.value !== this.section.text;
  }

  get videoURLChangedDisclaimerText() {
    return this.isVideoURLChanged? this.$t('lesson.disclaimerVideoURLChanged') : '';
  }

  init(name = '', urlVal = '') {
    this.form = EdFormModel([
      EdInputModel('name', name, { required, maxLength: maxLength(60) }),
      EdInputModel('url', urlVal, { required, url }),
    ]);
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  async saveVideo() {
    this.saving = true;
    let data: any = {
      type : this.params.type,
      name : this.form.name.value,
      text : this.form.url.value,
      parentId: this.params.parentId,
      courseId: this.params.courseId,
      classId: this.params.classId,
      labelSections: this.tagSelected,
      component: this.componentSelected
    }
    if(this.creating) {
      await this.createObject(data);
    } else {
      data = Object.assign({}, this.section);
      data.name = this.form.name.value;
      data.text = this.form.url.value;
      data.labelSections = this.tagSelected;
      data.component = this.componentSelected;
      data.archiveCurrentHomeworks = this.isVideoURLChanged;
      await this.editObject(data);        
    }     
    this.closeModal();
  }

  created() {
    if(SectionsProvider.getSectionById(this.course.sections, this.params.objId) !== null) {
      this.section = SectionsProvider.getSectionById(this.course.sections, this.params.objId).value;
    }
    this.title = this.params.titleModal || '';
    if(this.creating) {
      this.init();
      if(this.course.eduacComponents) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    } else {
      this.init(this.section.name, this.section.text);
      this.tagSelected = this.section.labelSections;
      if(this.section.component) {
        this.componentSelected = this.components.find(c => c.id == this.section.component.id);
      } else if(this.components) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    }
  }

}
